import React from 'react';
import { PageEmbeddedApp } from './apps';
import { IconActionsMenu } from '../../library/cms/page-components';
import { ReactHint } from '../../library/components/components';
import { PageToolbarController } from './toolbar';
import { MediaManagerController } from '../../library/cms/media-manager';
export class BlogSummaryItem extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "page-summary"
    }, /*#__PURE__*/React.createElement("div", {
      className: "page-info"
    }, /*#__PURE__*/React.createElement("a", {
      className: "page-summary-link",
      href: "/Blog"
    }, "Blog Posts")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
      href: "/Blog"
    }, /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "launch"))));
  }

}
export class PageSummaryItem extends React.Component {
  constructor(props) {
    super(props);
    this.getType = this.getType.bind(this);
  }

  getType(isEmbeddedPage) {
    return isEmbeddedPage ? 'App' : 'User Created';
  }

  onMenuSelected(event) {
    var item = event.detail.item;
    var value = item.dataset.value;
    this.props.onPageActionSelected(value, this.props.item);
  }

  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "page-summary"
    }, /*#__PURE__*/React.createElement("div", {
      className: "page-info"
    }, /*#__PURE__*/React.createElement("a", {
      className: "page-summary-link",
      href: this.props.item.permalink
    }, this.props.item.title), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
      className: "light"
    }, "Type: "), /*#__PURE__*/React.createElement("span", null, this.getType(this.props.item.isEmbeddedPage))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
      className: "light"
    }, "Last Updated: "), /*#__PURE__*/React.createElement("span", null, this.props.item.dateSummary), /*#__PURE__*/React.createElement("span", {
      className: "light"
    }, " Edited by:"), /*#__PURE__*/React.createElement("span", {
      className: "highlight"
    }, this.props.item.editedBy))), /*#__PURE__*/React.createElement("div", {
      className: "light"
    }, this.props.item.isEmbeddedPage ? /*#__PURE__*/React.createElement(IconActionsMenu, {
      item: this.props.item,
      onMenuSelected: this.onMenuSelected.bind(this),
      active: true
    }, /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "edit",
      "data-id": "edit"
    }, "Edit"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "settings",
      "data-id": "settings"
    }, "Settings")) : /*#__PURE__*/React.createElement(IconActionsMenu, {
      item: this.props.item,
      onMenuSelected: this.onMenuSelected.bind(this),
      active: true
    }, /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "edit",
      "data-id": "edit"
    }, "Edit"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "settings",
      "data-id": "settings"
    }, "Settings"), /*#__PURE__*/React.createElement("li", {
      className: "mdc-list-item",
      role: "menuitem",
      tabIndex: "0",
      "data-value": "delete",
      "data-id": "delete"
    }, "Delete"))));
  }

}
export class PagesSummary extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var nodes = this.props.items.map(item => {
      return /*#__PURE__*/React.createElement(PageSummaryItem, {
        key: item.id,
        item: item,
        onPageActionSelected: this.props.onPageActionSelected
      });
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "page-summary-container"
    }, this.props.enableBlog && /*#__PURE__*/React.createElement(BlogSummaryItem, null), nodes, this.props.items.length < 1 && /*#__PURE__*/React.createElement("div", {
      className: "page-summary"
    }, /*#__PURE__*/React.createElement("div", {
      className: "page-info"
    }, "There are currently no pages available...")));
  }

}
export class PagesSummaryApp extends PageEmbeddedApp {
  constructor(props) {
    super(props);
    this.state.collection = this.props.initialData.collection;
  }

  componentDidMount() {
    super.componentDidMount();
  }

  onMediaClick(event) {
    this.mediaController.mode = 'browse';
    this.mediaController.show();
  }

  onPageActionSelected(action, item) {
    switch (action) {
      case 'edit':
        location.href = item.permalink;
        break;

      case 'settings':
        this.setPageEntity(item);
        this.showSettings();
        break;

      case 'delete':
        this.deletePage(item.id);
        this.onDeletePage(item.id);
        break;
    }
  }

  onDeletePage(id) {
    var pages = this.arrayDeleteItemById(this.state.collection, id);
    this.state.collection = pages;
    this.setState(this.state.collection);
  }

  handleSettings(item) {
    this.setPageEntity(item);
  }

  onDashboardClick(event) {
    location.href = '/Admin';
  }

  onPageCreateClick(event) {
    this.createPage();
  }

  render() {
    var title = 'Pages';
    if (this.props.title) title = this.props.title;
    var enablePageCreate = true;
    if (this.props.disablePageCreate) enablePageCreate = false;
    return /*#__PURE__*/React.createElement("div", {
      className: "relative"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex-box between align-center"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "page-summary-title"
    }, title), /*#__PURE__*/React.createElement("div", {
      className: "pages-dashboard-icons"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ReactHint, {
      events: true,
      position: "top"
    }), /*#__PURE__*/React.createElement("i", {
      className: "material-icons",
      "data-rh": "Media",
      onClick: this.onMediaClick.bind(this)
    }, "add_a_photo")), this.props.enableDashboard && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ReactHint, {
      events: true,
      position: "top"
    }), /*#__PURE__*/React.createElement("i", {
      className: "material-icons",
      "data-rh": "Dashboard",
      onClick: this.onDashboardClick.bind(this)
    }, "dashboard")), enablePageCreate && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ReactHint, {
      events: true,
      position: "top"
    }), /*#__PURE__*/React.createElement("i", {
      className: "material-icons",
      "data-rh": "Create",
      onClick: this.onPageCreateClick.bind(this)
    }, "create")))), /*#__PURE__*/React.createElement(PagesSummary, {
      items: this.state.collection,
      onPageActionSelected: this.onPageActionSelected.bind(this),
      ref: ref => this.list = ref,
      enableBlog: this.props.enableBlog
    }), /*#__PURE__*/React.createElement(PageToolbarController, {
      showToolbar: this.props.initialData.showToolbar,
      onCommand: this.onCommand.bind(this),
      mode: this.mode,
      authorized: true,
      ref: ref => this.toolbarController = ref,
      onCreateDialogAccept: this.onCreateDialogAccept.bind(this),
      onCreateDialogCancel: this.onCreateDialogCancel.bind(this),
      onSettingsDialogAccept: this.onSettingsDialogAccept.bind(this),
      onSettingsDialogCancel: this.onSettingsDialogCancel.bind(this)
    }), /*#__PURE__*/React.createElement(MediaManagerController, {
      postUrl: this.props.initialData.mediaFilePostUrl,
      data: this.props.initialData.media,
      ref: ref => this.mediaController = ref
    }));
  }

}
export default PagesSummaryApp;